<div appClickStopPropagation class="flex w-full flex-row">
  <div class="grow"></div>

  <gx-dropdown [menuItems]="items" [item]="item" [label]="label" [icon]="menuIcon"></gx-dropdown>

  <ng-template #item let-menuItem let-component="component">
    @if (!menuItem.isRouterLink) {
      <div
        class="hover:bg-ui-surface flex flex-row items-center justify-between gap-4 p-2 hover:cursor-pointer"
        (click)="menuItem.clickEvent(); navigation.emit($event)"
        [attr.data-testid]="'item-' + menuItem.id">
        <button>{{ menuItem.label | translate }}</button>
        <fa-icon [icon]="getIcon(menuItem.id)" />
      </div>
    }

    @if (menuItem.isRouterLink) {
      <a
        [routerLink]="menuItem.routerLink"
        class="hover:bg-ui-surface flex flex-row items-center justify-between gap-4 p-2 hover:cursor-pointer"
        (click)="navigation.emit($event)"
        [attr.data-testid]="'item-' + menuItem.id">
        <button>{{ menuItem.label | translate }}</button>
        <fa-icon [icon]="getIcon(menuItem.id)" />
      </a>
    }
  </ng-template>

  <div class="grow"></div>
</div>
